import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";

HighchartsMore(Highcharts);

export const pieChard = (
  title,
  subtitle,
  series,
  categories,
  customTooltip = null,
  onClick = null,
  percentage = false
) => {
  return {
    chart: {
      type: "pie"
    },
    title: {
      text: title,
      align: "center"
    },
    subtitle: {
      text: subtitle,
      align: "left"
    },
    tooltip: customTooltip || {
      formatter: function () {
        const color = this.point.color;
        return `
        <div class='HContainer align-center'>
      <span style="color:${color}; font-weight: bold;">${this.point.name} :</span> 
      <div class='VContainer' style="margin-left: 10px;">
      <span style="font-weight: bold;">${this.point.percentage}%</span>
      <span style="font-weight: bold;">(${this.y})</span>
        </div>
        </div>
    `;
      },
      useHTML: true
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: true,
          format: percentage
            ? "<b>{point.name}</b>: {point.percentage:.2f}%"
            : "<b>{point.name}</b>: {point.y}"
        },
        point: {
          events: {
            click: function () {
              if (onClick) {
                onClick(this);
              }
            }
          }
        }
      }
    },
    /** Highcharts exige `series` como array; el backend de proveedores ya lo envía así. */
    series: Array.isArray(series)
      ? series
      : series && typeof series === "object" && "data" in series
        ? [series]
        : []
  };
};
